// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Importhttps://ditty.ir/s
import axios from '@configs/axios'

export const fetchCryptoCurrencies = createAsyncThunk('currency/fetchCryptoCurrencies', async () => {
  return axios.get('/exchange_list')
    .then(res => {
      return {
        data: res.data.data
      }
    })
    .catch(err => {
      return {
        data: []
      }
    })

})

export const layoutSlice = createSlice({
  name: 'currency',
  initialState: {
    currencyList: [],
    activeCurrency: JSON.parse(window.localStorage.getItem('activeCurrency')) || {
      symbol: 'BTC', name: 'Bitcoin', min_amount: 0.0005, labels: { fa: 'بیت کوین', en: 'Bitcoin' }
    }
  },
  reducers: {
    handleActiveCurrency: (state, action) => {
      console.log(action.payload)
      state.activeCurrency = action.payload
    },
    handleSearchQuery: (state, action) => {
      state.query = action.payload
    },
    addCoins: (state, action) => {
      state.currencyList = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchCryptoCurrencies.fulfilled, (state, action) => {
        if (action.payload.data.length > 0) {
          state.currencyList = action.payload.data.map(c => ({ ...c, symbol: c.symbol.toLowerCase() }))
        }
      })
  }
})

export const { handleSearchQuery, addCoins, handleActiveCurrency } = layoutSlice.actions

export default layoutSlice.reducer
